// extracted by mini-css-extract-plugin
export default {"root":"nu84UJ"};